
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  Renderer2,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  QueryList,
  DOCUMENT
} from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  AbstractControl,
  ValidatorFn,
  FormControl,
} from '@angular/forms';
import { Router } from '@angular/router';
import { PaymentService } from '@core/payments/services/payment.service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { LoaderService } from '@shared/services/loader.service';
import { TransactionService } from '@shared/services/transaction.service';
import { getValidationConfigFromCardNo } from 'src/app/helpers/card.helper';
import { luhnValidator } from 'src/app/validators/luhnValidator';
import { environment } from 'src/environments/environment';
import { jwtDecode } from 'jwt-decode';
import { EnableModulesService } from '@shared/services/enable-modules.service';
import { Subscription } from 'rxjs';
import { CardAdministrationService } from '@core/card-administration/services/card-administration.service';
declare var $: any;
declare var Flex: any;

interface ISaveCardResponse {
  resultCode: string;
  resultMessage?: string;
  errorCode?: string;
  result: {
    paid_amount?: string;
    reversed_amount?: string;
    date_time?: string;
  };
}

@Component({
    selector: 'app-save-card-page',
    templateUrl: './save-card-page.component.html',
    styleUrls: ['./save-card-page.component.css'],
    standalone: false
})
export class SaveCardPageComponent implements AfterViewInit {
  @ViewChild('iframe') iframe!: ElementRef;
  public uploadcard: boolean = false;
  public numbermodule: number = 0;
  formPayment: FormGroup;
  textoSinFormato: any;
  dueInitial: number = 1;
  cardType: any = '';
  formValid = false;
  isButtonEnabled = false;
  buttonClass = '';
  backgroundImg = '';
  infoClass = '';
  cvvClass = 'noshow';
  cardInfoNumber: string = '';
  cardInfoExpire: string = '';
  cardInfoName: string = '';
  cvv: string = '';
  saveCard: boolean = true;
  franchise: string = '';
  idSessionToken: string = '';
  cardinalAction: string =
    environment.centinel_domain + environment.cardinal_action;
  jwtCardinal: string = '';
  successCollectionCardinal = false;
  count: number = 10;
  iframeAuthContent: any = '';
  flexSrc = environment.microform_src;
  canEnrAutPay = localStorage.getItem('canEnrAutPay');
  canRegCard = localStorage.getItem('canRegCard');
  afiliateCard: boolean = false;
  private microform: any;
  private timeOutCentinel = false;
  private iframeChallengeWidth: number = 0;
  private iframeChallengeHeight: number = 0;
  private transientToken: string = '';
  private token: string = '';
  private cardBin: string = '';
  expirationDate: string = '';
  binCard: string = '';
  maskedValue: string = '';
  cardExpirationDate: string = '';
  formattedMaskedValue: string = '';
  onlyLinkAutomaticDebit: boolean = false;
  emailForDom: string = '';
  processError: boolean = false;

  public listObservers$: Array<Subscription> = [];

  @ViewChild('cardinalForm') cardinalForm!: ElementRef<HTMLFormElement>;
  private readonly modalRef!: NgbModalRef;

  constructor(
    private readonly fb: FormBuilder,
    public _cardAdministrationService: CardAdministrationService,
    private readonly _transactionService: TransactionService,
    private readonly router: Router,
    private readonly _loaderService: LoaderService,
    @Inject(DOCUMENT) private readonly _document: Document,
    private readonly element: ElementRef,
    private readonly _renderer2: Renderer2,
    private readonly cdr: ChangeDetectorRef,
    private readonly modalService: NgbModal,
    private readonly moduleService: EnableModulesService,
    private readonly elementRef: ElementRef
  ) {
    this.emailForDom = this._cardAdministrationService.emailFromDom;
    this.formPayment = this.fb.group({
      expirationDate: [
        '',
        [Validators.required, Validators.minLength(5), this.DateValidator()],
      ],
      emailAddress: [
        {
          value: this.emailForDom ? this.emailForDom : '',
          disabled: this.emailForDom == '' ? false : true,
        },
        [
          Validators.required,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ],
      ],
      isLinked: [this.saveCard],
      aceptarterminos: ['', Validators.required],
      afiliartarjeta: [this.onlyLinkAutomaticDebit],
    });
  }

  ngAfterViewInit(): void {
    $('[data-toggle="tooltip"]').tooltip();

    const checkboxContainer = this.elementRef.nativeElement.querySelector(
      '.form-check.example-section'
    );

    if (checkboxContainer) {
      checkboxContainer.remove();
    }
  }

  ngOnInit(): void {
    const onlyLinkAutomaticDebit = localStorage.getItem(
      'onlyLinkAutomaticDebit'
    );
    this.onlyLinkAutomaticDebit =
      onlyLinkAutomaticDebit == 'true' ||
      this._cardAdministrationService.uploadcard
        ? true
        : false;
    this.formPayment.controls['afiliartarjeta'].setValue(
      this.onlyLinkAutomaticDebit
    );
    this.addFingerPrintScript();
    this.initMicroform();

    this.formPayment.valueChanges.subscribe(() => {
      this.formValid = false;
      this.isButtonEnabled = false;
      if (this.formPayment.valid && this.formPayment.value.aceptarterminos) {
        this.formValid = true;
        this.isButtonEnabled = true;
      }
      this.buttonClass = this.isButtonEnabled
        ? 'btnPrimary'
        : 'btnPrimaryDisabled';
    });
  }

  ngOnDestroy() {
    window.removeEventListener(
      'message',
      this.dataCollectionResponseCardinal.bind(this)
    );
    this.listObservers$.forEach((o) => o.unsubscribe());
  }

  sendFormCP(): void {
    this.formPayment.controls['isLinked'].setValue(this.saveCard);
    const bodyRequest = this.formPayment.value;

    if (this.onlyLinkAutomaticDebit === true) {
      bodyRequest.afiliartarjeta = this.onlyLinkAutomaticDebit;
    }
    bodyRequest.idSession = this.idSessionToken;
    bodyRequest.franchise = this.cardType;
    this._loaderService.blockLoading();
    const expirationDate = bodyRequest.expirationDate.split('/');

    const options = {
      expirationMonth: expirationDate[0],
      expirationYear: '20' + expirationDate[1],
    };
    this.microform.createToken(options, (err: any, token: string) => {
      if (err) {
        // handle error
      } else {
        this.transientToken = token;
        this._cardAdministrationService.tokencard = token;

        const decodedPayload = this.decodeToken(token);

        this.cardBin =
          decodedPayload.content.paymentInformation.card.number.bin;
        this.maskedValue =
          decodedPayload.content.paymentInformation.card.number.maskedValue;
        this.expirationDate =
          decodedPayload.content.paymentInformation.card.expirationMonth.value +
          '/' +
          decodedPayload.content.paymentInformation.card.expirationYear.value;
        this.formattedMaskedValue = this.formatMaskedValue(
          decodedPayload.content.paymentInformation.card.number.maskedValue,
          this.cardBin
        );
        this._cardAdministrationService.bindcardgen = this.formattedMaskedValue;
        this._cardAdministrationService.expiratesdatecard = this.expirationDate;
        this._cardAdministrationService.email = bodyRequest.emailAddress;
        bodyRequest.transientToken = token;
        bodyRequest.captureContext = localStorage.getItem('captureContext');
        this._cardAdministrationService.bodyrequestcard = bodyRequest;
        //this.binCard = this.formattedMaskedValue;
        this.cardExpirationDate = this.expirationDate;
        this._cardAdministrationService.afilcard = false;
        if (bodyRequest.afiliartarjeta) {
          this._cardAdministrationService.afilcard = true;
        }
        this._cardAdministrationService.numbermodule = 1;
      }
    });
  }

  async sendPaymentForm(bodyRequest?: any): Promise<ISaveCardResponse | any> {
    return new Promise((resolve, reject) => {
      this._cardAdministrationService.bindBankCard(bodyRequest).subscribe(
        (response: ISaveCardResponse) => {
          resolve(response);
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  justNumbersDate(event: any) {
    // Eliminar todos los caracteres que no sean números ni "/"
    const inputValue = event.target.value;
    const numbersAndSlashOnly = inputValue.replace(/[^0-9/]/g, '');
    event.target.value = numbersAndSlashOnly;
  }

  dateFormat(value: any) {
    if (!isNaN(value.value) && value.value !== null) {
      const formattedDate = value.value.replace(/\D/g, '');
      if (formattedDate.length > 2) {
        const month = formattedDate.substring(0, 2);
        const year = formattedDate.substring(2);
        this.formPayment.controls['expirationDate'].setValue(
          `${month}/${year}`
        );
      }
    }
  }

  public DateValidator(): ValidatorFn {
    return () => {
      const expirationDateVar = this.formPayment?.get('expirationDate')?.value;
      if (!expirationDateVar) {
        // expirationDateVar es indefinida o nula
        return null; // O devuelve un error personalizado si es necesario
      }
      const arrayDate = expirationDateVar.split('/');
      const currentYear: any = new Date().getFullYear();
      const currentMonth = new Date().getMonth() + 1;
      const month = arrayDate[0];
      const year = arrayDate[1];
      if (isNaN(month) || isNaN(year)) {
        return { isValid: true };
      }
      if (parseInt(month) > 12) {
        return { isValid: true };
      }
      if (parseInt(year) < currentYear.toString().substr(2, 4)) {
        return { isValid: true };
      }
      if (parseInt(year) == currentYear.toString().substr(2, 4)) {
        if (parseInt(month) < currentMonth) {
          return { isValid: true };
        }
      }
      return null;
    };
  }

  /**
   * Integra seguimiento de transacciones con script de t1.
   */
  addFingerPrintScript() {
    // SCRIPT FINGERPRINT
    const randomBytes = new Uint8Array(15);
    const rerollBytes = crypto.getRandomValues(randomBytes);
    this.idSessionToken = this.bytesToHex(rerollBytes);
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      environment.t1_fingerscript_src +
      '?org_id=' +
      environment.t1_orgid_dfp +
      '&session_id=' +
      localStorage.getItem('t1_merchant_id') +
      this.idSessionToken;

    this._renderer2.appendChild(this._document.head, script);

    //IFRAME FINGERPRINT
    let noscript = this._renderer2.createElement('noscript');
    let iframeT1 = this._renderer2.createElement('iframe');
    iframeT1.src =
      environment.t1_fingerscript_src +
      '?org_id=' +
      environment.t1_orgid_dfp +
      '&session_id=' +
      localStorage.getItem('t1_merchant_id') +
      this.idSessionToken;
    iframeT1.style =
      'width: 100px; height: 100px; border: 0; position:absolute; top: -5000px;';
    this._renderer2.appendChild(noscript, iframeT1);
    this._renderer2.appendChild(this._document.body, noscript);
  }

  private bytesToHex(bytes: Uint8Array): string {
    return Array.from(bytes)
      .map((byte) => byte.toString(16).padStart(2, '0'))
      .join('');
  }

  private init3ds(result: any) {
    const { jwtAuth, lastResponseT1 } = result;

    this.jwtCardinal = jwtAuth;
    this.cdr.detectChanges();
    window.addEventListener(
      'message',
      this.dataCollectionResponseCardinal.bind(this)
    );
    if (this.cardinalForm && this.cardinalForm.nativeElement) {
      this.cardinalForm.nativeElement.submit();
    }
  }

  private dataCollectionResponseCardinal(event: MessageEvent) {
    if (event.origin === environment.centinel_domain) {
      const { MessageType, Status } = JSON.parse(event.data);
      if (
        MessageType == 'profile.completed' &&
        Status &&
        !this.timeOutCentinel
      ) {
        this.successCollectionCardinal = true;
        this.payerAuthenticationEnroll();
      }
    } else if (event.origin === environment.callback) {
      this.continuePaymentAuth();
    }
  }

  payerAuthenticationEnroll() {
    const bodyRequest = this._cardAdministrationService.bodyrequestcard;
    const now = new Date();
    const timeDifference = now.getTimezoneOffset();
    bodyRequest.centinelCollection = true;
    bodyRequest.idSession = this.idSessionToken;
    bodyRequest.deviceInformation = {
      httpBrowserColorDepth: screen.colorDepth,
      httpBrowserJavaEnabled: false,
      httpBrowserJavaScriptEnabled: true,
      httpBrowserLanguage: navigator.language,
      httpBrowserScreenHeight: screen.height,
      httpBrowserScreenWidth: screen.width,
      httpBrowserTimeDifference: timeDifference,
      userAgentBrowserValue: navigator.userAgent,
    };
    bodyRequest.transientToken = this.transientToken;
    bodyRequest.captureContext = localStorage.getItem('captureContext');
    this._cardAdministrationService
      .enrollPendingAuth(bodyRequest)
      .subscribe((transactionSummary) => {
        const { resultCode, result } = transactionSummary;
        if (resultCode === 'PENDING_REVIEW') {
          this.startStepUpAuth(result);
        } else {
          this._cardAdministrationService.callback.emit(transactionSummary);
        }
      });
  }

  private startStepUpAuth(result: any) {
    const { jwtAuth, stepUpUrl, windowSize } = result;
    const iframeSice = this.getIframeSize(windowSize);
    this.jwtCardinal = jwtAuth;
    this.buildIframeStepUp(jwtAuth, stepUpUrl);
  }

  private getIframeSize(windowSize: string) {
    switch (windowSize) {
      case '01':
        this.iframeChallengeWidth = 250;
        this.iframeChallengeHeight = 400;
        break;
      case '02':
        this.iframeChallengeWidth = 390;
        this.iframeChallengeHeight = 400;
        break;
      case '03':
        this.iframeChallengeWidth = 500;
        this.iframeChallengeHeight = 600;
        break;
      case '04':
        this.iframeChallengeWidth = 600;
        this.iframeChallengeHeight = 400;
        break;
      case '05':
      default:
        this.iframeChallengeWidth = 1080;
        this.iframeChallengeHeight = 1920;
        break;
    }
  }

  private buildIframeStepUp(jwtAuth: string, stepUpUrl: string) {
    //this.modalRef = this.modalService.open(this.modalAuth, { centered: true });
    // SCRIPT FINGERPRINT

    // CREACION DE IFRAME
    const iframe = this._renderer2.createElement('iframe');
    iframe.name = 'step-up-iframe';
    iframe.height = this.iframeChallengeHeight.toString();
    iframe.width = this.iframeChallengeWidth.toString();

    this._renderer2.setStyle(iframe, 'backgroundColor', '#ffffff');

    // CREACION DE FORMULARIO
    const form = document.createElement('form');
    form.id = 'step-up-iframe';
    form.target = 'step-up-iframe';
    form.method = 'POST';
    form.action = stepUpUrl;

    //CREACION DE INPUT JWT
    const input = this._renderer2.createElement('input');
    input.name = 'JWT';
    input.type = 'hidden';
    input.value = jwtAuth;

    this._renderer2.appendChild(form, input);
    this.cdr.detectChanges();
    const container = this.element.nativeElement.querySelector(
      '#div-autentications'
    );

    this._renderer2.appendChild(container, iframe);
    this._renderer2.appendChild(container, form);
    form.submit();
    this._loaderService.unBlockLoaging();
    $('#modalIframeAuth').modal('show');
    //ENVIA EL FORMULARIO UNA VEZ INMEDIATAMENTE DESPUES DE RENDERIZAR
  }

  public continuePaymentAuth() {
    $('#modalIframeAuth').modal('hide');
    const bodyRequest = this._cardAdministrationService.bodyrequestcard;
    bodyRequest.idSession = this.idSessionToken;
    bodyRequest.transientToken = this.transientToken;
    bodyRequest.captureContext = localStorage.getItem('captureContext');
    this._cardAdministrationService
      .validateAuthResult(bodyRequest)
      .subscribe((transactionSummary) => {
        const { resultCode, result } = transactionSummary;
        this._cardAdministrationService.callback.emit(transactionSummary);
      });
  }

  initMicroform() {
    const script = this._renderer2.createElement('script');
    script.type = 'text/javascript';
    script.src = this.flexSrc;
    script.onload = () => {
      var customStyles = {
        input: {
          'font-size': '16px',
        },
        ':hover': {
          'font-style': 'italic',
        },
        ':disabled': {
          cursor: 'not-allowed',
        },
        valid: {
          color: 'green',
        },
        invalid: {
          color: 'red',
        },
      };
      const flex = new Flex(localStorage.getItem('captureContext'));
      this.microform = flex.microform({ styles: customStyles });
      const number = this.microform.createField('number', {
        placeholder: 'Número de tarjeta',
      });
      const securityCode = this.microform.createField('securityCode', {
        placeholder: '***',
      });
      number.load('#cardNumber');
      securityCode.load('#cardSC');
    };
    this._renderer2.appendChild(document.body, script);
  }

  decodeToken(token: string): any {
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken;
    } catch (error) {
      return null;
    }
  }

  formatMaskedValue(maskedValue: string, bin: string): string {
    const firstFourBin = bin.slice(0, 4); // Obtener los primeros 4 dígitos del bin
    const lastDigits = maskedValue.slice(-4); // Obtener los últimos 4 dígitos del maskedValue
    const maskedSection = '*'.repeat(maskedValue.length - 8); // Crear los asteriscos para la sección enmascarada

    return `${firstFourBin}${maskedSection}${lastDigits}`;
  }

  isConfirmationPageActive(): boolean {
    return this.moduleService.getConfirmationPage();
  }

  disableConfirmationPage(): void {
    this.moduleService.setConfirmationPage(false);
  }

  linkDebitValidator(event: any) {
    if (this.onlyLinkAutomaticDebit) {
      event.preventDefault();
    }
  }

  tyc() {
    this._cardAdministrationService.numbermodule = -1;
    this._cardAdministrationService.tyc = true;
  }

  async onActionTriggered(event: boolean) {
    try {
      if (!event) {
        this._cardAdministrationService.numbermodule = 0;
        return;
      }

      this._cardAdministrationService.bodyrequestcard.emailAddress =
        this._cardAdministrationService.emailFromDom;
      this._cardAdministrationService.bodyrequestcard.afiliartarjeta = false;
      this._cardAdministrationService.bodyrequestcard.uploadCard = true;
      this._cardAdministrationService.afilcard = true;
      this._cardAdministrationService.bodyrequestcard.processId =
        localStorage.getItem('processId');

      const transactionSummary: ISaveCardResponse = await this.sendPaymentForm(
        this._cardAdministrationService.bodyrequestcard
      );

      window.parent.postMessage(transactionSummary, '*');

      this._loaderService.hideLoading();
      this._cardAdministrationService.finalServiceResponse = transactionSummary;
      console.log('EXITO', transactionSummary);
      this.router.navigate(['/card-administration/process-confirmation']);
    } catch (error) {
      console.log('ERRORRR', error);
      this._loaderService.hideLoading();
      this.router.navigate(['/card-administration/process-confirmation']);
    }
  }
}
